import styled from "styled-components";

import * as Types from "Types";

const Input = styled.input<Types.Default>`
   border: none;
   color: #000;
   border-bottom: 1px solid #000;
   width: 230px;
   height: 26px;
   padding: 3.5px 1px;
   box-sizing: border-box;
   font-size: 13px;
   outline: none;
   ${({ css }) => css}
   &::placeholder {
      color: #000;
   }
`;

export default function SearchInput(props: any) {
   console.log("search input props", props);
   return <Input {...props} placeholder="지역, 전시, 아트페어 검색"></Input>;
}
